<div class="npdc-title">
  <h1>Labels</h1>
  <div class="npdc-title__actions">
    <a mat-flat-button routerLink="new">New label</a>
  </div>
</div>

<p>A label can be added to a dataset to mark it with a project or programme.</p>

<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      <mat-icon>search</mat-icon>
    </div>
    <input
      type="search"
      placeholder="Search in labels…"
      [value]="q()"
      (keydown.enter)="onSearchEvent($event)"
    />
  </div>
</div>

<app-list [resource]="labels" [disableClear]="true">
  @if (!labels.error()) {
    <mat-nav-list>
      @for (label of labels.value()?.items; track label.id) {
        <a mat-list-item routerLink="{{ label.id }}/edit">
          <mat-icon matListItemIcon>label</mat-icon>
          <span matListItemTitle>{{ label.title }}</span>
          <span matListItemLine>{{ label.type }}</span>
          @if (label.url) {
            <span matListItemLine>{{ label.url }}</span>
          } @else {
            <span matListItemLine>n/a</span>
          }
        </a>
      }
    </mat-nav-list>

    <mat-paginator
      showFirstLastButtons
      (page)="onPageEvent($event)"
      [length]="labels.value()?.count"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[10, 20, 50, 100]"
    >
    </mat-paginator>
  }
</app-list>
